/* eslint-disable */
import { Button, ButtonMode, ButtonSize } from '@creditsights/styleguide-web';
import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { formatDate } from '../../../utils/date.utils';
import { hasMoreData } from '../../../utils/page.utils';

import './DocumentSearchHighlights.scss';

function DocumentSearchHighlights({ data, sort, pageSize, updateSort, fetchNextPage, isFetchingNextPage }) {
  const SORT_OPTIONS = [
    {
      id: null,
      label: 'Relevance',
    },
    {
      id: 'issuer',
      label: 'Master Issuer',
    },
    {
      id: 'issue_name',
      label: 'Issue Name',
    },
    {
      id: 'docName',
      label: 'Document',
    },
    {
      id: 'maturity_date',
      label: 'Maturity Date',
    },
    {
      id: 'issue_date',
      label: 'Issue Date',
    },
  ];

  const [selection, setSelection] = useState<any>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!selection) {
      if (data?.pages[0].results.length > 0) {
        setSelection(data?.pages[0].results[0]);
      } else {
        setSelection(null);
      }
    }
  }, [data, sort]);

  const renderSourceDocument = () => {
    if (selection.docType === 'Research Report') {
      return <span></span>;
    } else {
      const { docUrl, file } = selection;
      let url = '';

      if (docUrl) {
        url = docUrl;
      } else if (file) {
        const splits = file.split('/');
        url = splits
          .map((i, index) => {
            if (index === splits.length - 1) {
              return encodeURIComponent(i);
            } else {
              return i;
            }
          })
          .join('/');
      }

      return (
        <a target="_blank" href={docUrl}>
          <i className="file alternate outline icon"></i> Document
        </a>
      );
    }
  };

  const renderTitle = (item) => {
    const { issuer, issue_name } = item;
    let title = issue_name;

    if (issuer && title.toLowerCase().indexOf(issuer?.toLowerCase()) === -1) {
      const i = issuer.charAt(0).toUpperCase() + issuer.slice(1);
      title = `${i} ${issue_name}`;
    }

    return (
      <>
        <span>{title}</span>
        <span className="doc-name">({item.docName})</span>
      </>
    );
  };

  return (
    <div className="cs-document-search-highlights">
      <div className="sort-ctx">
        <div className="text">Sort Order:</div>
        {SORT_OPTIONS.map((option) => (
          <Button key={option.id} mode={sort.field === option.id ? ButtonMode.SECONDARY : ButtonMode.PLAIN} size={ButtonSize.X_SMALL} onClick={() => updateSort(option.id)}>
            {sort?.field === option.id && <i className={`sort amount icon ${sort?.order === 'asc' ? 'up' : 'down'}`}></i>} {option.label}
          </Button>
        ))}
      </div>
      <div className="results">
        <div className="list">
          {data.pages.map((page) =>
            page.results.map((item) => (
              <div className={`item ${selection?.key === item.key ? 'selected' : ''}`} key={item.key} onClick={() => setSelection(item)}>
                <div className="title">{renderTitle(item)}</div>
                <div className="properties">
                  <div className="issuer">{item.issuer}</div>
                  {item.issue_date && (
                    <>
                      <div className="dot"></div>
                      <div className="date">Issue Date: {formatDate(item.issue_date)}</div>
                    </>
                  )}
                  {item.maturity_date && (
                    <>
                      <div className="dot"></div>
                      <div className="date">Maturity Date: {formatDate(item.maturity_date)}</div>
                    </>
                  )}
                  {item.industry && (
                    <>
                      <div className="dot"></div>
                      <div className="date">{item.industry}</div>
                    </>
                  )}
                </div>
              </div>
            ))
          )}

          {hasMoreData(data, pageSize, data?.pages[0]?.totalResults) && (
            <div className="next-page">
              <Button mode={ButtonMode.PRIMARY} size={ButtonSize.MEDIUM} loading={isFetchingNextPage} disabled={isFetchingNextPage} onClick={() => fetchNextPage()}>
                Load {pageSize} more
              </Button>
            </div>
          )}
        </div>
        {selection && (
          <div className="preview">
            <div className="title">{renderTitle(selection)}</div>
            <div className="sub">
              <div className="information">
                <div className="doc-type">
                  {selection.docType} <span className="doc-name">({selection.docName})</span>
                </div>
              </div>
              <div className="actions">
                {renderSourceDocument()}
                <NavLink to={`/articles/${selection.id}`}>
                  Full Article <i className="share square outline icon"></i>
                </NavLink>
              </div>
            </div>
            <div className="highlights">
              {selection.highlights.map((highlight, index) => (
                <div key={selection.id + '-' + index} className="highlight" dangerouslySetInnerHTML={{ __html: `... ${highlight} ...` }}></div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DocumentSearchHighlights;
